import { render, staticRenderFns } from "./index.bak.vue?vue&type=template&id=237c6a1c&scoped=true"
import script from "./index.bak.vue?vue&type=script&lang=js"
export * from "./index.bak.vue?vue&type=script&lang=js"
import style0 from "./index.bak.vue?vue&type=style&index=0&id=237c6a1c&prod&lang=less&scoped=true"
import style1 from "./index.bak.vue?vue&type=style&index=1&id=237c6a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c6a1c",
  null
  
)

export default component.exports